// import { WSIBClassList } from "components/WSIBClass";

import { AuthenticatedLayout } from "../../layouts";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { FC } from "react";
import { WSIBClassList } from "../../components/WSIBClassList";

export interface IWSIBClassListPage { }

export const WSIBClassListPage: FC<IWSIBClassListPage> = (
  props: IWSIBClassListPage
) => {
  return (
    <AuthenticatedLayout
      pageTitle="WSIB Class List"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[]}
      mainContents={<WSIBClassList />}
    />
  );
};
